<template>
    <div class="input_search_container">
        <v-autocomplete class="input_de_pesquisa"  :class="{redBorda : redColorActive}" :loading="isLoading_" placeholder="Pesquisar aluno"
        outlined v-model="editedItem" :items="alunos" :search-input.sync="search" color="primary"
        item-text="nome" append-icon="search" auto-select-first clearable return-object @click="loadStudents()" @change="selecionarEstudante()"></v-autocomplete>
    </div>
</template>

<script>
import _axios from '../../../../plugins/axios'
import Swal from 'sweetalert2'
export default {
  data () {
    return {
      isLoading_: false,
      search: '',
      foto: '',
      alunos: [],
      editedItem: {
        anoLectivo: '',
        bi: '',
        curso: '',
        data_: '',
        foto: '',
        idMatricula: '',
        instituicao: '',
        nome: '',
        pkPessoa: 0,
        resultado: '',
        turma: ''
      },
      defaultItem: {
        anoLectivo: '',
        bi: '',
        curso: '',
        data_: '',
        foto: '',
        idMatricula: '',
        instituicao: '',
        nome: '',
        pkPessoa: 0,
        resultado: '',
        turma: ''
      }
    }
  },

  props: {
    redColorActive: Boolean
  },

  watch: {
    
    /**
         * Método responsavél por observar sempre que o input é preenchido
         * Se o input tiver palavras digitada,
         * executará a função InitializarEstudanteLocal()
        */
    search (val) {
      if (val && val.length > 0) {
        return this.pesquisaEstudante(val)
      }
    }
  },

  methods: {
    loadStudents () {
      this.pesquisaEstudante('a')
    },
    /**
         * Método responsavél por carregar a lista de todos
         estudante cujo a descrição bate com o valor inserido
         * Exibe uma notificação caso ocorra um erro
        */
    async pesquisaEstudante (searchInDb) {
      try {
        let payload
        if (!searchInDb) payload = '{"find":"all"}'
        else payload = '{"find":"' + searchInDb + '"}'
        this.isLoading_ = true
        this.alunos = await _axios.get('/pesquisaByEstudante/' + payload).then(res => res.data)
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar estudantes' })
      } finally {
        this.isLoading_ = false
      }
    },

    /**
         * Método responsavél por enviar o estudante escolhido para o componente pai
        */
    selecionarEstudante () {
      this.$emit('estudanteEscolhido', this.editedItem)
      this.search = ''
      this.editedItem = this.defaultItem
      this.alunos = []
    }
  }
}
</script>

<style>
.input_search_container, .input_de_pesquisa {
    border-radius: 35px;
    text-align: center;
}

.redBorda {
    border: 2px dotted transparent;
    animation: flashBorder .5s linear infinite alternate;
}

@keyframes flashBorder {
    0% {
        border-color: transparent;
    }

    100% {
        border-color: #ff0000;
    }
}</style>
